/* global axios */
import ApiClient from './ApiClient';

class ConversationSubscribersApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  subscribe(conversationId, pubsubToken = null) {
    return axios.post(`${this.url}/${conversationId}/subscribers`, {
      pubsub_token: pubsubToken,
    });
  }

  unsubscribe(conversationId, pubsubToken = null) {
    return axios.delete(`${this.url}/${conversationId}/subscribers`, {
      data: {
        pubsub_token: pubsubToken,
      },
    });
  }
}

export default new ConversationSubscribersApi();
